// extracted by mini-css-extract-plugin
export default {"row":"WorkspaceEdit_row__Hc9vg","pe25":"WorkspaceEdit_pe25__rspZG"};